import { useEffect, useState } from "react";

import { addToast } from "@icg360/design-system";

import { usePoliciesList, usePolicyPlatformId } from "data/ss-data-hooks";
import { switchPolicy, trackEvent } from "utils";

export const useRemovePolicy = () => {
  const { data, mutate: refetchPolicies } = usePoliciesList();
  const selectedPlatformId = usePolicyPlatformId();
  const [showRemovePolicyModal, setShowRemovePolicyModal] = useState(false);
  const [removePolicyInfo, setRemovePolicyInfo] = useState();

  useEffect(() => {
    if (showRemovePolicyModal) {
      const { policyState: policyStatus } = removePolicyInfo ?? {
        policyState: "",
      };
      trackEvent("Remove policy modal displayed (profile)", { policyStatus });
    }
  }, [showRemovePolicyModal, removePolicyInfo]);

  const handlers = {
    openRemovePolicyModal: (policyInfo) => {
      trackEvent("Remove Policy Started", {
        listOfPolicy: data?.map((p) => p.platformPolicyId),
      });

      setRemovePolicyInfo(policyInfo);
      setShowRemovePolicyModal(true);
    },
    closeRemovePolicyModal: () => setShowRemovePolicyModal(false),
    handleRemovePolicySucceeded: async (oldPolicyPlatformId) => {
      const updatedPolicies = await refetchPolicies();

      const { policyState: policyStatus } = removePolicyInfo ?? {
        policyState: "",
      };

      if (oldPolicyPlatformId === selectedPlatformId) {
        const nextPolicy = updatedPolicies?.find(
          (p) => p.platformPolicyId !== oldPolicyPlatformId,
        );
        if (nextPolicy) {
          switchPolicy(nextPolicy.keystonePolicyId, "/my/settings");
          return;
        }
      }

      setShowRemovePolicyModal(false);
      addToast("Policy has been successfully removed from your account.", {
        icon: true,
      });

      trackEvent("Remove Policy Success Message Displayed", {
        oldPolicyId: oldPolicyPlatformId,
        policyStatus,
      });
    },
  };

  return {
    removePolicyState: {
      showRemovePolicyModal,
      removePolicyInfo,
    },
    removePolicyHandlers: handlers,
  };
};
